module.exports = __webpack_public_path__ + "img/flecha-atras.994b8fc0.png";